import * as React from "react";
import Router from "./modules/Routing/Router";
import ReduxToastr from "react-redux-toastr";
import { useSelector } from "react-redux";
import { RouteModuleProvider } from "src/modules/Routing/context/RouteModule";
import { IReduxState } from "./reduxTypes";
import ErrorBoundary from "./share/components/ErrorPage/ErrorBoundary";
import { PhotoViewerProvider } from "./share/context/PhotoViewerProvider";
import { CurrentRouteProvider } from "./modules/Routing/auth/CurrentRouteContext";
import NavBar from "./modules/Navigation/NavBar/NavBar";
import { useHistory } from "react-router";
import { IsSessionExpiredProvider } from "src/modules/Auth/AuthExpiration/AuthExpirationContext";
import { AuthModal } from "src/modules/Auth/AuthModal/AuthModal";
import NetwotkDetector from "./share/hoc/NetworkDetector";
import { RouteStateProvider } from "./share/context/RouteStateProvider";

export interface ICaseUIState {
  isModalOpen: boolean;
}
// modal
// refreshSession: (username: string, refreshToken: string) => any;
const App = () => {
  const history = useHistory();
  const username = useSelector(
    (reduxState: IReduxState) => reduxState.auth.username
  );
  return (
    <div>
      <ErrorBoundary username={username} history={history}>
        <RouteModuleProvider>
          <CurrentRouteProvider>
            <IsSessionExpiredProvider>
              <NetwotkDetector />
              <NavBar />
              <PhotoViewerProvider>
                <RouteStateProvider>
                  <Router />
                </RouteStateProvider>
              </PhotoViewerProvider>
              <AuthModal />
            </IsSessionExpiredProvider>
          </CurrentRouteProvider>
        </RouteModuleProvider>
        <ReduxToastr
          timeOut={7000}
          newestOnTop={false}
          preventDuplicates={true}
          position="top-right"
          transitionIn="fadeIn"
          transitionOut="fadeOut"
          progressBar={true}
        />
      </ErrorBoundary>
    </div>
  );
};

export default App;



// WEBPACK FOOTER //
// ./src/app.tsx